<template>
  <Modal v-model="showModal" :mask-closable="false" width="500px">
    <div slot="header">{{showLang('com.export.fn.pole')}}</div>
    <Form ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem prop="name" :label="showLang('com.tab.title')" style="margin-right: 15px">
        <div class="flex-row">
          <Input type="text" v-model="form.name" :placeholder="showLang('com.tab.title')"></Input>
        </div>
      </FormItem>
      <FormItem prop="code" :label="showLang('com.device.pole.code')" style="margin-right: 15px">
        <div class="flex-row">
          <Input type="text" disabled v-model="form.code" :placeholder="showLang('com.sys.generate')"></Input>
        </div>
      </FormItem>
      <FormItem prop="stationId" :label="showLang('com.site.associated')" style="margin-right: 15px">
        <Select :placeholder="showLang('save.select')" v-model="form.stationId">
          <Option v-for="(s, idx) in stations" :key="idx" :value="s.id">{{s.name}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="poleType" :label="showLang('com.import.cn.pole.type')" style="margin-right: 15px">
        <Input type="text" v-model="form.asset.poleType"></Input>
      </FormItem>
      <FormItem prop="poleType" :label="showLang('com.import.cn.arm.type')" style="margin-right: 15px">
        <Input type="text" v-model="form.asset.armType"></Input>
      </FormItem>
      <FormItem prop="height" :label="showLang('com.import.cn.pole.height')" style="margin-right: 15px">
        <Input type="number" number v-model="form.asset.height">
        <span slot="append">M</span>
        </Input>
      </FormItem>
      <FormItem prop="lng" :label="showLang('com.import.cn.lng')">
        <Input ref="lng" type="text" v-model="form.lng" :placeholder="showLang('import.lng.installation.location')" style="width: 270px;margin-right: 10px">
        </Input>
        <Button type="primary" @click="selectPos">选择</Button>
      </FormItem>
      <FormItem prop="lat" :label="showLang('com.import.cn.lat')">
        <Input ref="lat" type="text" v-model="form.lat" :placeholder="showLang('import.lat.installation.location')">
        </Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">{{showLang('com.op.cancel')}}</Button>
      <Button type="primary" :loading="loading" @click="ok">{{showLang('com.op.save')}}</Button>
    </div>
    <ModalSelectMapPoint v-model="showMapModal" :custCenter="pos" @posSelected="posSelected" />
    <!-- <ModalSelectGroup v-model="showSelectModal" @newGroupSelected="newGroupSelected" /> -->
  </Modal>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ModalSelectMapPoint from '@/views/common/modals/ModalSelectMapPoint'
export default {
  name: 'ModalPoleEdit',
  components: {
    ModalSelectMapPoint,
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() { return {}; }
    },
    stations: {
      type: Array,
      default() { return []; }
    },
  },
  data() {
    return {
      showModal: this.value,
      // showSelectModal: false,
      loading: false,
      showMapModal: false,
      isAdd: false,
      types: [],
      groupName: '',
      mains: [],
      devices: [],
      pos: {
        area: '',
        lat: 0,
        lng: 0,
      },
      form: {
        id: 0,
        stationId: 0,
        code: '',
        name: '',
        lng: '',
        lat: '',
        asset: {
          //资产配置相关
          poleType: '', //灯杆类型
          armType: '', //灯臂类型
          height: 8, //高度
        }
      },
      rules: {
      },
    }
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        // console.log('modal level edit mounted', this.item)
        this.isAdd = this.item.isAdd;
        if (!this.isAdd) {
          // debugger;
          this.form.id = this.item.data.id;
          this.form.stationId = this.item.data.stationId;
          this.form.name = this.item.data.name;
          this.form.code = this.item.data.code;
          this.form.lng = this.item.data.lng;
          this.form.lat = this.item.data.lat;
          this.form.asset = {
            //资产配置相关
            poleType: this.item.data.poleType, //灯杆类型
            armType: this.item.data.armType, //灯臂类型
            height: this.item.data.hight, //高度
          }
          // for(let k in this.form.asset){
          //   this.form.asset[k] = this.item.data.asset[k];
          // }
        } else {
          this.form.id = 0;
          this.form.stationId = 0;
          this.form.code = '';
          this.form.name = '';
          this.form.lng = "";
          this.form.lat = "";
          this.form.asset = {
            //资产配置相关
            poleType: '', //灯杆类型
            armType: '', //灯臂类型
            height: 8, //高度
          }
        }
      }
    },
    showModal(val) {
      this.$emit('showChanged', val);
    },
  },
  computed: {
    ...mapState('auth', ['config']),
    ...mapGetters('auth', ['showLang']),
  },
  mounted: function () {
  },
  methods: {
    selectPos: function(){
      let lat = this.form.lat;
      let lng = this.form.lng;
      if(!lat){
        lat = this.config.lat;
        lng = this.config.lng;
      }
      this.pos = {
        area: this.config.area,
        lat: lat,
        lng: lng,
      };
      this.showMapModal = true;
    },
    posSelected: function(params){
      console.log('pos sel', params, this.config);
      this.form.lat = params.lat;
      this.form.lng = params.lng;
    },
    ok: async function () {
      if (this.form.name.trim().length == 0) {
        this.$Message.warning(this.showLang('save.name'));
        return;
      }
      if (this.form.stationId <= 0) {
        this.$Message.warning(this.showLang('save.site.associated'));
        return;
      }
      // if(this.form.content.group <= 0 || this.form.content.group > 255){
      //   this.$Message.warning('分组号必须在 1 - 255 之间');
      //   return;
      // }
      this.$axios.post(`//${this.domains.trans}/station/config/SaveLampPole`, this.form).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
        } else {
          this.$Message.info(this.showLang('com.tips.save'));
          this.showModal = false;
          this.$emit('saved', { isAdd: this.isAdd, data: res.data });
          window.eventBus.$emit('poleChanged');
        }
      })
    },
    cancel() {
      this.showModal = false;
      // this.$refs.form.resetFields();
    },
  }
}
</script>
<style scoped>
.form-item-group {
  border: solid 1px rgba(129, 124, 124, 0.377);
  border-radius: 12px;
  margin-bottom: 15px;
}
.group-header {
  /* border: solid 1px blue; */
  background-color: rgba(221, 216, 216, 0.808);
  margin-bottom: 15px;
  height: 35px;
  border-radius: 12px 12px 0 0;
  line-height: 35px;
  font-weight: bold;
  padding: 0 10px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.form {
  height: calc(100% - 54px);
  overflow: auto;
}
.readonly {
  background: #eee;
}
</style>